import React from 'react';
import { Outlet } from 'react-router-dom';
import { userAppData } from '../MainApp.js';
import './PerformanceManagement.css';

// Parent container for the Performance Management module. Ensures permissions are validated before loading any child routes.
export default function PerformanceManagement() {
    const performancePerms = userAppData['performanceManagement']?.perms ?? 0;

    if (performancePerms === 1) {
        return (
            <div className="performance-management-wrapper">
                <Outlet />
            </div>
        );
    }

    return (
        <div className="performance-management-no-access">
            <h2 className="performance-management-no-access__heading">Performance Management</h2>
            <p className="performance-management-no-access__copy">
                You currently do not have permission to view this module. If you believe this is an error, please contact your system administrator.
            </p>
        </div>
    );
}
